import type { Dispatch, SetStateAction } from 'react';
import { useSessionStorage } from 'usehooks-ts';

export const useStoreOtpPhoneValidated = (
	isOtpPhoneValidatedInit: boolean,
): [boolean, Dispatch<SetStateAction<boolean>>, () => void] => {
	const OTP_PHONE_VALIDATED = 'OTP_PHONE_VALIDATED';
	return useSessionStorage(OTP_PHONE_VALIDATED, isOtpPhoneValidatedInit);
};
